import CompanyProfileForm from "./company-profile-form";

export default CompanyProfileForm;